function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M5.857,10.929a7.7,7.7,0,0,1,7.691-7.691H28.335A4.444,4.444,0,0,0,24.072,0H5.452A4.456,4.456,0,0,0,1,4.452v25.1A4.456,4.456,0,0,0,5.452,34h.4Z",
  transform: "translate(-1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M29.072,4H10.452A4.456,4.456,0,0,0,6,8.452V31.929a4.456,4.456,0,0,0,4.452,4.452h18.62a4.456,4.456,0,0,0,4.452-4.452V8.452A4.456,4.456,0,0,0,29.072,4ZM25.834,31.525H13.691a1.214,1.214,0,0,1,0-2.429H25.834a1.214,1.214,0,0,1,0,2.429Zm0-6.476H13.691a1.214,1.214,0,1,1,0-2.429H25.834a1.214,1.214,0,1,1,0,2.429Zm0-5.667H13.691a1.214,1.214,0,1,1,0-2.429H25.834a1.214,1.214,0,1,1,0,2.429Zm0-6.476H13.691a1.214,1.214,0,1,1,0-2.429H25.834a1.214,1.214,0,1,1,0,2.429Z",
  transform: "translate(2.095 2.476)"
});

const SvgIconProtocolo = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.62,
    height: 38.858,
    viewBox: "0 0 35.62 38.858",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconProtocolo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Protocolo.55658b9b.svg";
export { ForwardRef as ReactComponent };